import {styled} from "@mui/material/styles";
import { Grid, IconButton, FormControlLabel } from '@mui/material';
import { useColors } from "../../../../Context/ColorsContext";
import { MediaQuerys } from "../../../../styles/GlobalStyle";

const { mobile, tablet, desktop, desktoplarge } = MediaQuerys;

export const CustomGrid = styled(Grid)(() => {
    return {
        fontSize: 14,
        border: '1px solid #ccc',
        '> .MuiGrid-item': {
            padding: 2,
            paddingLeft: 6,
            border: '1px solid #ccc',
        }
    }
})

export const RemoveIconButton = styled(IconButton)(() => {
    const { colors } = useColors();
    return {
        borderRadius: '10%',
        backgroundColor: colors.background,
        color: colors.buttonActionColor,
        padding: 2,
        "&:hover": {
            backgroundColor: colors.buttonActionColor,
            opacity: 0.8,
            color: colors.background
        }
    }
})

export const StickyHeader = styled(Grid)(() => {
    const { colors } = useColors();
    return {
        position: "sticky",
        top: 0,
        height: 'auto',
        color: colors.grayFont,
        backgroundColor: colors.gray, // Customize this background color as needed
        zIndex: 1, // Ensure the header stays above the content when scrolling
        fontWeight: 'bold',
        fontSize: '12px',
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center'
    };
});

export const CustomControlLabel = styled(FormControlLabel)(() => {
    return {
        margin: 0,
      [desktop]: {
        '& .MuiTypography-root': {
          fontSize: '0.85rem',
        }
      }
    }
  })
